// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton-loading_skeleton__sii87","skeletonShimmer":"skeleton-loading_skeletonShimmer__Ur2v9","block":"skeleton-loading_block__kVVIX"};